import api from '../../../util/api';

const list = () => {
    const url = '/wording/list';
    return api.get(url);
};

export default { list };



// WEBPACK FOOTER //
// ./src/components/pages/wording/wordingService.js